module.exports = __webpack_public_path__ + "d5ac7870d62bc99ef37b59b1fde8dffc.png";